import type { OpenWindowConfig } from "../os-layout/useWindow";
import type { ContentNode } from "./contentNode";
import { putReadableContent } from "./readableContentStore";

export interface OpenReadableContentOptions {
  title: string;
  content: ContentNode;
}

function escapeHtml(text: string): string {
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

/** Fallback when aniOS is unavailable — opens a simple reader tab. */
export function openReadableContentFallbackTab({
  title,
  content,
}: OpenReadableContentOptions): void {
  const display = JSON.stringify(content, null, 2);
  const popup = window.open("", "_blank", "width=760,height=640,noopener");
  if (!popup) return;

  popup.document.title = title;
  popup.document.body.innerHTML = `
    <style>
      body { margin: 0; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; background: #0f172a; color: #e2e8f0; }
      header { padding: 12px 16px; border-bottom: 1px solid #334155; font-family: system-ui, sans-serif; font-size: 14px; font-weight: 600; }
      pre { margin: 0; padding: 16px; white-space: pre-wrap; word-break: break-word; line-height: 1.55; font-size: 12px; }
    </style>
    <header>${escapeHtml(title)}</header>
    <pre>${escapeHtml(display)}</pre>
  `;
  popup.document.close();
}

export function openReadableContent(
  options: OpenReadableContentOptions,
  openWindow: ((config: OpenWindowConfig) => void) | null
): void {
  const contentId = putReadableContent(options);
  if (openWindow) {
    openWindow({
      appId: "readable-content",
      title: options.title,
      params: { contentId },
    });
    return;
  }
  openReadableContentFallbackTab(options);
}
